var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"read-only":!_vm.access.update_access || _vm.disabled,"config":_vm.editorConfig},on:{"ready":function($event){_vm.first_load = false},"namespaceloaded":_vm.onNamespaceLoaded},model:{value:(_vm.input_text),callback:function ($$v) {_vm.input_text=$$v},expression:"input_text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }